import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, FormControl, InputLabel, Select, MenuItem, Box, FormHelperText } from '@mui/material';

const AnnouncementForm = ({ open, onClose, onSubmit, initialData, title = 'Add Announcement', loading = false, teachers = [] }) => {
  const [formData, setFormData] = useState({ title: '', message: '', audience: 'all_teachers', target_user_id: '' });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (initialData) {
      setFormData({
        title: initialData.title || '',
        message: initialData.message || '',
        audience: initialData.audience || 'all_teachers',
        target_user_id: initialData.target_user_id || '',
      });
    } else {
      setFormData({ title: '', message: '', audience: 'all_teachers', target_user_id: '' });
    }
    setErrors({});
  }, [initialData, open]);

  const handleChange = (field) => (e) => {
    const value = e.target.value;
    setFormData(prev => ({ ...prev, [field]: value }));
    if (errors[field]) setErrors(prev => ({ ...prev, [field]: '' }));
  };

  const validate = () => {
    const n = {};
    if (!formData.title.trim()) n.title = 'Title is required';
    if (!formData.message.trim()) n.message = 'Message is required';
    if (['single_teacher'].includes(formData.audience) && !formData.target_user_id) n.target_user_id = 'Select a user';
    setErrors(n);
    return Object.keys(n).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    const payload = { ...formData };
    if (!['single_teacher'].includes(payload.audience)) delete payload.target_user_id;
    if (initialData?.id) payload.id = initialData.id;
    await onSubmit(payload);
  };

  const showTarget = ['single_teacher'].includes(formData.audience);
  const targetOptions = teachers;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Box component="form" sx={{ mt: 1 }}>
          <TextField fullWidth margin="normal" label="Title" value={formData.title} onChange={handleChange('title')} error={!!errors.title} helperText={errors.title} required />
          <FormControl fullWidth margin="normal">
            <InputLabel>Audience</InputLabel>
            <Select value={formData.audience} onChange={handleChange('audience')} label="Audience">
              <MenuItem value="all">All</MenuItem>
              <MenuItem value="all_teachers">All Teachers</MenuItem>
              <MenuItem value="single_teacher">Single Teacher</MenuItem>
              <MenuItem value="all_parents">All Parents</MenuItem>
            </Select>
          </FormControl>
          {showTarget && (
            <FormControl fullWidth margin="normal" error={!!errors.target_user_id}>
              <InputLabel>Target User</InputLabel>
              <Select value={formData.target_user_id} onChange={handleChange('target_user_id')} label="Target User">
                {targetOptions.map(u => (
                  <MenuItem key={u.id} value={u.id}>{u.full_name}</MenuItem>
                ))}
              </Select>
              {errors.target_user_id && <FormHelperText>{errors.target_user_id}</FormHelperText>}
            </FormControl>
          )}
          <TextField fullWidth margin="normal" label="Message" value={formData.message} onChange={handleChange('message')} multiline rows={4} error={!!errors.message} helperText={errors.message} required />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSubmit} variant="contained" disabled={loading}>{initialData?.id ? 'Update' : 'Create'}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default AnnouncementForm;


